const fieldsets = document.querySelectorAll('.js-c-fieldset--collapsible')

fieldsets.forEach(initFieldset)

function initFieldset(fieldset) {
  const id = fieldset.id
  const trigger = fieldset.querySelector('.js-fieldset-collapsible--trigger')
  const panel = fieldset.querySelector('.js-fieldset-collapsible--content')
  const icon = fieldset.querySelector('.js-fieldset-collapsible--icon')

  if (!trigger || !panel || !id) return

  let sessionValue = sessionStorage.getItem(id)
  let isOpen = sessionValue === 'true' || (sessionValue === null && panel.offsetHeight > 0)

  if (isOpen) {
    panel.classList.remove('tw-hidden')
    panel.style.height = 'auto'
    trigger.setAttribute('aria-expanded', 'true')
    setTabbable(true)
  } else {
    panel.style.height = '0px'
    trigger.setAttribute('aria-expanded', 'false')
    setTabbable(false)
  }

  if (icon) icon.classList.toggle('tw-rotate-180', isOpen)

  function openFieldset() {
    panel.style.height = panel.scrollHeight + 'px'
    trigger.setAttribute('aria-expanded', 'true')
    isOpen = true
    sessionStorage.setItem(id, 'true')
    icon?.classList.add('tw-rotate-180')
    setTabbable(true)

    panel.addEventListener('transitionend', () => {
      if (isOpen) {
        panel.style.height = 'auto'
        panel.classList.remove('tw-overflow-hidden')
      }
    }, { once: true })
  }

  function closeFieldset() {
    panel.style.height = panel.scrollHeight + 'px'
    panel.classList.add('tw-overflow-hidden')
    setTabbable(false)

    // If user is focused inside panel, shift focus out
    if (panel.contains(document.activeElement)) {
      const next = getNextFocusableElement(fieldset)
      if (next) next.focus()
    }

    requestAnimationFrame(() => {
      panel.style.height = '0px'
    })

    trigger.setAttribute('aria-expanded', 'false')
    isOpen = false
    sessionStorage.setItem(id, 'false')
    icon?.classList.remove('tw-rotate-180')
  }

  function toggleAccordion() {
    isOpen ? closeFieldset() : openFieldset()
  }

  function handleKeydown(event) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault()
      toggleAccordion()
    }
  }

  trigger.addEventListener('click', toggleAccordion)
  trigger.addEventListener('keydown', handleKeydown)

  // Shift+Tab back into closed fieldset → focus trigger, not hidden fields
  panel.addEventListener('keydown', (e) => {
    if (e.key === 'Tab' && e.shiftKey && !isOpen) {
      e.preventDefault()
      trigger.focus()
    }
  })

  function setTabbable(enabled) {
    const focusables = panel.querySelectorAll(
      'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    )
    focusables.forEach(el => {
      if (!enabled) {
        el.setAttribute('tabindex', '-1')
      } else {
        el.removeAttribute('tabindex')
      }
    })
  }
}

function getFocusableElements(container = document) {
  return Array.from(
    container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )
  ).filter(el => el.offsetParent !== null)
}

function getNextFocusableElement(currentEl) {
  const focusables = getFocusableElements()
  const index = focusables.indexOf(currentEl)
  return focusables[index + 1] || null
}
